import React from "react";
import "./PrivacyPolicy.css";
import Navbar from '../Components/NavBarAirbnbStyle';
export default function PrivacyPolicy() {
  return (
    <>
    <Navbar/>
    <div className="privacy-container">
      <h1 className="privacy-title">Política de Privacidad</h1>
      <p>
        Al registrar tus datos, autorizas a <strong>LAOFI S.A.S.</strong> a tratarlos conforme a la
        Ley Orgánica de Protección de Datos Personales del Ecuador. Tu información será utilizada
        únicamente con fines promocionales y comerciales relacionados con nuestros servicios.
      </p>
      <p>
        En cualquier momento puedes ejercer tus derechos de acceso, rectificación, cancelación u
        oposición escribiendo a{" "}
        <a href="mailto:info@laofi.work">info@laofi.work</a>.
      </p>
      <p>
        Por tu registro accedes a una promoción de <strong>1 día gratis de coworking</strong>,
        válida de lunes a viernes, en horario de atención de 9h00 a 19h00.
      </p>
      <p>
        La promoción es personal, se aplica por una sola vez y, si asistes con un acompañante, él o
        ella también podrá acceder al beneficio sin costo adicional.
      </p>
      <p>
        Esta campaña busca generar una base de datos de clientes potenciales y brindar una
        experiencia directa del espacio.
      </p>
      <p>
        La información comercial proporcionada en los spots publicitarios sobre cursos de
        capacitación, talleres o actividades se encuentra sujeta a disponibilidad de horarios y
        aforo, por lo que <strong>LAOFI S.A.S.</strong> se reserva el derecho de modificar o ajustar
        su ejecución sin previo aviso.
      </p>
    </div></>
  );
}
